import { Component, OnInit } from '@angular/core';
import { AppConfig } from '../app.config';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  constructor(public config: AppConfig) { }

  ngOnInit() {
  }
  onChildData(value :any){
    switch(value.key){
     
    }
  }
}
